import * as React from 'react';

import { useIdentityClient } from '@/api/identity-client-context';
import { useAuth } from '@/auth/auth-context';
import { Button } from '@/components/ui/button';

// =============================================================================
// logout-button.tsx — « Se déconnecter » (T1-LOGOUT, §2.1).
// =============================================================================
// Rendu UNIQUEMENT pour un admin (role==='admin') : la déconnexion §2.1 est l'action
// admin. Au clic : révocation SERVEUR best-effort (adminLogout — l'autorité de révocation
// est l'API, transition d'état de admin_session) PUIS navigation pleine page vers la landing
// `/`. La navigation dure PURGE tout l'état d'auth client (mémoire React, RULE_REF_006),
// cohérente avec le CTA de login en <a href>. adminLogout ne jette jamais (best-effort) : la
// redirection a donc lieu quoi qu'il advienne.

export function LogoutButton(): React.JSX.Element | null {
  const auth = useAuth();
  const identity = useIdentityClient();
  const [pending, setPending] = React.useState(false);

  if (auth.role !== 'admin') {
    return null;
  }

  async function handleLogout(): Promise<void> {
    setPending(true);
    await identity.adminLogout();
    // Navigation pleine page : purge complète de l'état d'auth client avant retour landing.
    window.location.assign('/');
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={pending}
      onClick={() => {
        void handleLogout();
      }}
    >
      Se déconnecter
    </Button>
  );
}
